import type { ReactNode } from 'react';

import { cn } from './cn';

/**
 * Заглушка на час завантаження.
 *
 * Головне правило (§20 гайду): скелетон має повторювати геометрію того, що
 * зʼявиться. Скелетон іншої висоти зсуває верстку, і це гірше за спінер —
 * тому висоту завжди задає той, хто його ставить.
 */
export function Skeleton({ className }: { className?: string }): ReactNode {
	return <div aria-hidden="true" className={cn('animate-pulse rounded-md bg-surface-muted', className)} />;
}
